module.exports = __webpack_public_path__ + "static/media/package_dev_mobile_plain.2f5415b2.svg";